var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgApple = function SvgApple(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.26 12.17c-.2.16-3.75 2.15-3.75 6.6 0 5.14 4.51 6.96 4.65 7-.02.12-.72 2.5-2.38 4.92-1.49 2.13-3.03 4.26-5.39 4.26s-2.96-1.36-5.68-1.36c-2.65 0-3.6 1.41-5.75 1.41s-3.66-1.97-5.39-4.4c-2-2.85-3.62-7.27-3.62-11.47 0-6.74 4.38-10.3 8.7-10.3 2.28 0 4.2 1.5 5.63 1.5 1.37 0 3.5-1.6 6.1-1.6 1 0 4.54.1 6.88 3.44Zm-8.11-6.29a7.74 7.74 0 0 0 1.84-4.82c0-.25-.02-.5-.07-.7a7.75 7.75 0 0 0-5.1 2.63 7.53 7.53 0 0 0-1.9 4.69c0 .27.04.54.06.63.11.02.3.04.48.04 1.57 0 3.55-1.05 4.69-2.47Z"
  })));
};
export default SvgApple;